import { dispatcher, api } from '@unicus/react-ui-kit';

export const CAMPAIGN = 'CAMPAIGN';

export const CAMPAIGN_CLONE_FETCH = 'CAMPAIGN_CLONE_FETCH';
export const CAMPAIGN_CLONE_FETCH_FINISHED = 'CAMPAIGN_CLONE_FETCH_FINISHED';

export const clone = (id, onSuccess) => async (dispatch) => {
  await dispatcher.dispatchResouceAction({
    dispatch,
    resource: 'campaigns',
    actionType: CAMPAIGN_CLONE_FETCH,
    effect: async () => api.post(`campaigns/${id}/clone`),
    onSuccess
  });
};
